import { transitions } from '../transactions/transactionProcessBooking';

export const CHECKOUT_PAGE_STEPS = {
  SHIPPING_ADDRESS: 'shippingAddress',
  SHIPPING_PAYMENT: 'payment',
};

export const SHIPPING_PREFERENCE = {
  SHIPPING: 'shipping',
  PICKUP: 'pickup',
};

export const LANGUAGE_OPTIONS = {
  EN: 'en',
  FR: 'fr',
};

export const EQUIPMENT = 'equipement';

export const VISHAL = '14021997';


